import { combineReducers } from 'redux'

import { apiKeyFormProfile } from './apiKeyForm'
import { apiKeysProfile } from './apiKeys'

export const apiKeysReducer = combineReducers({
  apiKeyFormProfile,
  apiKeysProfile
})
